namespace $.$$ {

	export class $shm_hitalama_color_pick extends $.$shm_hitalama_color_pick {

		click() {
			this.showed( false )
		}

	}

}
